import { render, staticRenderFns } from "./PricingOptions.vue?vue&type=template&id=f4a12718"
import script from "./PricingOptions.vue?vue&type=script&lang=js"
export * from "./PricingOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports